import { t } from "../internals/to-string-tag-support.js";
import { d as o } from "../internals/define-built-in.js";
import { o as r } from "../internals/object-to-string.js";
t || o(Object.prototype, "toString", r, {
  unsafe: !0
});